export const replaceLinks = (text: string, color: string, i: number = 0): Array<JSX.Element | string> => {
	const link = text.match(/\[(?<title>.*?)]\((?<link>.*?)\)/);
	if (link && link.groups) {
		const splitText = text.split(link[0]);
		return [
			splitText[0],
			<a key={'link' + i} style={{ color }} href={link.groups.link} target="_blank" rel="noreferrer noopener">
				{link.groups.title}
			</a>,
			...replaceLinks(splitText[1], color, i + 1),
		];
	}
	return [text];
};

// const replaceJsx = (text: string, find: string, replace: JSX.Element): Array<JSX.Element | string> => {
// 	return text
// 		.split(find)
// 		.flatMap((item) => [item, replace])
// 		.slice(0, -1);
// };
